<template>
    <div class="bracket-category-item" :class="{ 'has-text-grey': status.dimmed }">
        <span class="icon is-small" :class="status.iconColorClass" :title="status.label">
            <i :class="status.icon" :aria-label="status.label" role="img"></i>
        </span>
        <span class="bracket-category-name">{{ bracket.name }}</span>
        <BracketTypeBadge v-if="bracket.isPersisted" :fight="bracket" />
        <span class="bracket-category-count" :title="translate('common.competitors')">
            <span>{{ bracket.eligibleCompetitors }}</span>
            <span class="icon" aria-hidden="true"><i class="fas fa-users"></i></span>
        </span>
    </div>
</template>

<script setup lang="ts">
    import { computed } from "vue";
    import BracketTypeBadge from "../Common/BracketTypeBadge.vue";
    import { translate } from "../Common/translations";
    import { ComplexBracket } from "../Common/Brackets/types";

    const props = defineProps<{
        bracket: ComplexBracket;
    }>();

    type BracketCategoryStatus = {
        icon: string;
        iconColorClass: string;
        label: string;
        dimmed: boolean;
    };

    const status = computed<BracketCategoryStatus>(() => {
        if (props.bracket.isOutdated) {
            return {
                icon: "fas fa-exclamation-triangle",
                iconColorClass: "has-text-danger",
                label: translate("common.bracket_outdated"),
                dimmed: false,
            };
        }
        if (props.bracket.isPersisted) {
            return {
                icon: "fas fa-check-circle",
                iconColorClass: "has-text-success",
                label: translate("bracket_category_select.status_up_to_date"),
                dimmed: false,
            };
        }
        if (!props.bracket.isWorthGenerating) {
            return {
                icon: "fas fa-minus",
                iconColorClass: "has-text-grey",
                label: translate("bracket_category_select.status_too_few_competitors"),
                dimmed: true,
            };
        }
        return {
            icon: "far fa-circle",
            iconColorClass: "has-text-grey-light",
            label: translate("bracket_category_select.status_not_created"),
            dimmed: false,
        };
    });
</script>

<style scoped>
    .bracket-category-item {
        display: flex;
        align-items: center;
        gap: 0.5em;
        color: inherit;
    }

    .bracket-category-name {
        flex-grow: 1;
        min-width: 0;
    }

    .bracket-category-count {
        display: flex;
        align-items: center;
        gap: 0.25em;
        margin-left: 1em;
        white-space: nowrap;
    }
</style>
